// ─── Cores ────────────────────────────────────────────────────────────────────

export const darkTokens = {
  // Backgrounds
  bgApp:         '#0e1a1f',
  bgSidebar:     '#111c22',
  bgCard:        '#152028',
  bgCardHover:   '#19272f',
  bgInput:       '#192830',
  bgActive:      '#0d4f52',

  // Brand
  teal:          '#14b8a0',
  tealDark:      '#0d9488',
  tealGlow:      'rgba(20,184,160,0.18)',
  tealBorder:    'rgba(20,184,160,0.45)',

  // Text
  textPrimary:   '#e8f0f2',
  textSecondary: '#7fa3b0',
  textMuted:     '#4a6a78',

  // Borders
  border:        'rgba(255,255,255,0.06)',
  borderCard:    'rgba(255,255,255,0.08)',

  // Status
  online:        '#14b8a0',
  offline:       '#f87171',
  statusActiveBg:'rgba(20,184,160,0.15)',

  // Radius (mantidos para backward compat com theme.ts)
  radiusSm: 8, radiusMd: 14, radiusLg: 18,
}

export const lightTokens = {
  // Backgrounds
  bgBody:        '#f0f4f8',
  bgApp:         '#ffffff',
  bgSidebar:     '#f8fafb',
  bgCard:        '#ffffff',
  bgCardHover:   '#f5f9fa',
  bgInput:       '#f0f4f6',
  bgActive:      '#e6f7f5',

  // Brand
  teal:          '#0d9488',
  tealLight:     '#14b8a0',
  tealGlow:      'rgba(13,148,136,0.12)',
  tealBorder:    'rgba(13,148,136,0.35)',

  // Text
  textPrimary:   '#0f2b35',
  textSecondary: '#4a7080',
  textMuted:     '#8aaabb',

  // Borders
  border:        'rgba(0,0,0,0.07)',
  borderCard:    'rgba(0,0,0,0.08)',

  // Status
  online:        '#0d9488',
  offline:       '#ef4444',

  // Radius (mantidos para backward compat com theme.ts)
  radiusSm: 8, radiusMd: 14, radiusLg: 18,
}

export type DarkTokens  = typeof darkTokens
export type LightTokens = typeof lightTokens
